
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
    components: {
        Paginator: () => import("@/components/Paginator.vue"),
        SortColumn: () => import("@/components/SortColumn.vue")
    },
    filters: {
        date(value: string) {
            return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
        }
    }
})
export default class BatchRequestList extends Vue {
    @Prop({ default: () => [] }) readonly items!: any[];
    @Prop({ default: 0 }) readonly totalRows!: number;
    @Prop({ default: () => [] }) readonly statuses!: any[];
    @Prop({ default: false }) readonly readonly!: boolean;
    @Prop({ default: () => [] }) readonly preselectedIds!: number[];
    @Prop({ default: () => [] }) readonly allIds!: number[];
    @Prop({ default: false }) readonly loading!: boolean;

    selectedIds: number[] = [];
    allSelected: boolean = false;
    limit: number = 10;
     currentSort: Record<string, string> = { col: "requests.batchId", dir: "DESC" };

    @Watch("preselectedIds", { immediate: true })
    onPreselectedChange(ids: number[]) {
        this.selectedIds = [...ids];
        this.syncAllSelected();
    }

    @Watch("items")
    onItemsChange() {
        this.syncAllSelected();
    }

    @Watch("allIds")
    onAllIdsChange() {
        this.syncAllSelected();
    }

    toggleSelect(request: any) {
        const isSelected = this.selectedIds.includes(request.id);
        if (isSelected) {
            this.selectedIds = this.selectedIds.filter(id => id !== request.id);
        } else {
            this.selectedIds = [...this.selectedIds, request.id];
        }
        this.syncAllSelected();
        this.$emit("selection-change", [...this.selectedIds]);
    }

    toggleSelectAll() {
        if (this.allSelected) {
            this.selectedIds = [];
        } else {
            this.selectedIds = [...this.allIds];
        }
        this.syncAllSelected();
        this.$emit("selection-change", [...this.selectedIds]);
    }

    syncAllSelected() {
        this.allSelected = this.allIds.length > 0 && this.allIds.every(id => this.selectedIds.includes(id));
    }

    onSortChange(sort: Record<string, string>) {
        this.currentSort = sort;
        this.$emit("sort-change", sort);
    }

    onPageChange(page: number, limit: number) {
        this.limit = limit;
        this.$emit("page-change", page, limit);
    }

    statusClass(status: number) {
        if (status === 0 || status === 1) return "active";
        if (status === 5) return "pending";
        return "inactive";
    }
}
